import ProgressBar from "@/components/common/progress-bar";
import TooltipButton from "@/components/common/tooltip";
import React, { useEffect, useRef, useState } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
// import { SERVER_API_URL } from "@/constants/server";
import { Chart as ChartJS, CategoryScale, LinearScale } from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Image from "next/image";
import Button from "@/components/common/button";
import {
  BusinesssTransformationSVG,
  ContinousImprovementSVG,
  DailyManagementSVG,
  InnovationSVG,
} from "./svgs/isa";
import Modal from "@/components/common/modal";
import { useContext } from "react";
import { AuthContext } from "@/context/AuthContext";
import "../../../../../assets/fonts/Lato/LatoInPDF/Lato-Black-normal";
import "../../../../../assets/fonts/Lato/LatoInPDF/Lato-Bold-normal";
import "../../../../../assets/fonts/Lato/LatoInPDF/Lato-Regular-normal";

import { isa_graphEN } from "@/assets/dictionaries/en/isa-content";
import { isa_graphES } from "@/assets/dictionaries/es/isa-content";

ChartJS.register(CategoryScale, LinearScale);
const SERVER_API_URL = process.env.NEXT_PUBLIC_SERVER_API_URL;

const IsaGraph = () => {
  const [isaGraphContent, setIsaGraphContent] = useState(isa_graphEN); // Default to English

  useEffect(() => {
    // Get the language from localStorage
    const lang = localStorage.getItem("selectedOption") || "EN"; // Default to EN if not found

    // Set the content based on the language
    switch (lang.toUpperCase()) {
      case "ES":
        setIsaGraphContent(isa_graphES);
        break;
      case "EN":
      default:
        setIsaGraphContent(isa_graphEN);
        break;
    }
  }, []); // Only run on mount

  const { auth } = useContext(AuthContext);
  const [displayEmailModal, setDisplayEmailModal] = useState(false);
  const [formToDisplay, setFormToDisplay] = useState<
    "email" | "success" | "error" | "wait" | "reset"
  >("email");

  let [indexQ, setIndexQ] = useState(0);
  let qstn_num = 22;
  let current = 100 / qstn_num;
  const [showTooltip, setShowTooltip] = useState(false);

  let [selectedOption, setSelectedOption] = useState<number>(0);
  const [commentValue, setCommentValue] = useState<string>("");

  let [expectations, setExpectations] = useState([0, 0, 0, 0]);
  let [effort, setEffort] = useState([0, 0, 0, 0]);

  let data = {
    labels: [
      [isaGraphContent.data_label_1, isaGraphContent.data_label_2],
      [isaGraphContent.data_label_3, isaGraphContent.data_label_4],
      [isaGraphContent.data_label_5, isaGraphContent.data_label_6],
      [isaGraphContent.data_label_7],
    ],

    datasets: [
      {
        label: isaGraphContent.data_set_1,
        data: effort,
        backgroundColor: "#96D31D",
      },
      {
        label: isaGraphContent.data_set_2,
        data: expectations,
        backgroundColor: "#4C9F6A",
      },
    ],
  };

  let [indexQEffort, setIndexQEffort] = useState(0);

  let [saved, setSavedData] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  let [commentGroup, setCommentGroup] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ]);

  let [calcDM, setCalcDM] = useState([0, 0, 0, 0, 0, 0, 0]);
  let [calcCI, setCalcCI] = useState([0, 0, 0, 0, 0, 0, 0]);
  let [calcBT, setCalcBT] = useState([0, 0, 0, 0, 0, 0, 0]);
  let [calcIN, setCalcIN] = useState([0, 0, 0, 0, 0, 0, 0]);

  let [calcDMEffort, setCalcDMEffort] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  let [calcCIEffort, setCalcCIEffort] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  let [calcBTEffort, setCalcBTEffort] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  let [calcINEffort, setCalcINEffort] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);

  const [formData, setFormData] = useState({
    name: "",
    last_name: "",
    email: "",
    phone_country_zone: "+1",
    phone_number: "",
  });
  const [authUserData, setAuthUserData] = useState<{ user_id: number | null }>({
    user_id: null,
  });

  const [formErrors, setFormErrors] = useState({
    name: "",
    last_name: "",
    email: "",
    phone_country_zone: "+1",
    phone_number: "",
  });

  const qstn = [
    isaGraphContent.qstn_1,
    isaGraphContent.qstn_2,
    isaGraphContent.qstn_3,
    isaGraphContent.qstn_4,
    isaGraphContent.qstn_5,
    isaGraphContent.qstn_6,
    isaGraphContent.qstn_7,
    isaGraphContent.qstn_8,
    isaGraphContent.qstn_9,
    isaGraphContent.qstn_10,
    isaGraphContent.qstn_11,
    isaGraphContent.qstn_12,
    isaGraphContent.qstn_13,
    isaGraphContent.qstn_14,
    isaGraphContent.qstn_15,
    isaGraphContent.qstn_16,
    isaGraphContent.qstn_17,
    isaGraphContent.qstn_18,
    isaGraphContent.qstn_19,
    isaGraphContent.qstn_20,
    isaGraphContent.qstn_21,
    isaGraphContent.qstn_22,
    isaGraphContent.qstn_23,
  ];

  const as1 = [
    isaGraphContent.as1_1,
    isaGraphContent.as1_2,
    isaGraphContent.as1_3,
    isaGraphContent.as1_4,
    isaGraphContent.as1_5,
    isaGraphContent.as1_6,
    isaGraphContent.as1_7,
    isaGraphContent.as1_8,
    isaGraphContent.as1_9,
    isaGraphContent.as1_10,
    isaGraphContent.as1_11,
    isaGraphContent.as1_12,
    isaGraphContent.as1_13,
    isaGraphContent.as1_14,
    isaGraphContent.as1_15,
    isaGraphContent.as1_16,
    isaGraphContent.as1_17,
    isaGraphContent.as1_18,
    isaGraphContent.as1_19,
    isaGraphContent.as1_20,
    isaGraphContent.as1_21,
    isaGraphContent.as1_22,
  ];

  const as2 = [
    isaGraphContent.as2_1,
    isaGraphContent.as2_2,
    isaGraphContent.as2_3,
    isaGraphContent.as2_4,
    isaGraphContent.as2_5,
    isaGraphContent.as2_6,
    isaGraphContent.as2_7,
    isaGraphContent.as2_8,
    isaGraphContent.as2_9,
    isaGraphContent.as2_10,
    isaGraphContent.as2_11,
    isaGraphContent.as2_12,
    isaGraphContent.as2_13,
    isaGraphContent.as2_14,
    isaGraphContent.as2_15,
    isaGraphContent.as2_16,
    isaGraphContent.as2_17,
    isaGraphContent.as2_18,
    isaGraphContent.as2_19,
    isaGraphContent.as2_20,
    isaGraphContent.as2_21,
    isaGraphContent.as2_22,
  ];

  const as3 = [
    isaGraphContent.as3_1,
    isaGraphContent.as3_2,
    isaGraphContent.as3_3,
    isaGraphContent.as3_4,
    isaGraphContent.as3_5,
    isaGraphContent.as3_6,
    isaGraphContent.as3_7,
    isaGraphContent.as3_8,
    isaGraphContent.as3_9,
    isaGraphContent.as3_10,
    isaGraphContent.as3_11,
    isaGraphContent.as3_12,
    isaGraphContent.as3_13,
    isaGraphContent.as3_14,
    isaGraphContent.as3_15,
    isaGraphContent.as3_16,
    isaGraphContent.as3_17,
    isaGraphContent.as3_18,
    isaGraphContent.as3_19,
    isaGraphContent.as3_20,
    isaGraphContent.as3_21,
    isaGraphContent.as3_22,
  ];

  const addinfo = [
    isaGraphContent.addinfo_1,
    isaGraphContent.addinfo_2,
    isaGraphContent.addinfo_3,
    isaGraphContent.addinfo_4,
    isaGraphContent.addinfo_5,
    isaGraphContent.addinfo_6,
    isaGraphContent.addinfo_7,
  ];

  const qstnConst = [
    [1, 3, 2, 3],
    [1, 1, 3, 3],
    [2, 1, 3, 3],
    [3, 3, 3, 1],
    [2, 1, 3, 2],
    [3, 2, 3, 1],
    [1, 2, 3, 1],
    [3, 3, 3, 1],
    [3, 3, 3, 1],
    [2, 3, 3, 1],
    [1, 1, 3, 1],
    [1, 1, 3, 1],
    [3, 3, 3, 3],
    [3, 2, 3, 1],
    [2, 1, 3, 1],
    [2, 2, 3, 3],
    [2, 1, 3, 3],
    [1, 1, 2, 3],
    [1, 1, 1, 3],
    [1, 1, 1, 3],
    [1, 1, 1, 3],
    [1, 1, 1, 3],
  ];

  function changeTooltip() {
    if (showTooltip) {
      setShowTooltip(false);
    } else {
      setShowTooltip(true);
    }
  }

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(parseInt(event.target.value, 10));
  };

  const handleCommentChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    setCommentValue(event.target.value);
  };

  function AcceptReset() {
    setIndexQ(0);
    setIndexQEffort(0);
    setSavedData([
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ]);
    setCommentGroup([
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ]);
    setCalcDM([0, 0, 0, 0, 0, 0, 0]);
    setCalcCI([0, 0, 0, 0, 0, 0, 0]);
    setCalcBT([0, 0, 0, 0, 0, 0, 0]);
    setCalcIN([0, 0, 0, 0, 0, 0, 0]);
    setExpectations([0, 0, 0, 0]);

    setCalcDMEffort([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    setCalcCIEffort([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    setCalcBTEffort([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    setCalcINEffort([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    setEffort([0, 0, 0, 0]);

    setSelectedOption(0);
    setCommentValue("");
    setShowTooltip(false);
    setDisplayEmailModal(false);
    setFormToDisplay("email");
  }

  function DeclineReset() {
    setDisplayEmailModal(false);
    setFormToDisplay("email");
  }

  function BtnReset() {
    setDisplayEmailModal(true);
    setFormToDisplay("reset");
  }

  function SaveDataAnswer(Index: number, IndexEffort: number) {
    const inputValue = commentValue;

    let expectationsCopy = expectations;
    let effortCopy = effort;

    let sumaDM = 0;
    let promDM = 0;
    let sumaCI = 0;
    let promCI = 0;
    let sumaBT = 0;
    let promBT = 0;
    let sumaIN = 0;
    let promIN = 0;

    let sumaDMEffort = 0;
    let promDMEffort = 0;
    let sumaCIEffort = 0;
    let promCIEffort = 0;
    let sumaBTEffort = 0;
    let promBTEffort = 0;
    let sumaINEffort = 0;
    let promINEffort = 0;

    let SavedDataCopy = saved;
    SavedDataCopy[Index] = selectedOption;
    setSavedData(SavedDataCopy);

    let commentGroupCopy = commentGroup;
    if (inputValue === "") {
      commentGroupCopy[Index] = isaGraphContent.no_comment;
    } else {
      commentGroupCopy[Index] = inputValue;
    }

    setCommentGroup(commentGroupCopy);

    if (Index <= 6) {
      // DAILY MANAGEMENT CALC
      if (selectedOption < qstnConst[Index][0] && selectedOption !== 0) {
        let calcDMCopy = calcDM;
        calcDMCopy[Index] = 1 - 0.25 * (qstnConst[Index][0] - selectedOption);
        setCalcDM(calcDMCopy);
      } else {
        if (selectedOption === qstnConst[Index][0]) {
          let calcDMCopy = calcDM;
          calcDMCopy[Index] = 1;
          setCalcDM(calcDMCopy);
        } else {
          let calcDMCopy = calcDM;
          calcDMCopy[Index] = 0;
          setCalcDM(calcDMCopy);
        }
      }
      for (let i = 0; i <= 6; i++) {
        sumaDM = sumaDM + calcDM[i];
      }
      promDM = Math.round((sumaDM / 7) * 100);

      expectationsCopy[0] = promDM;
      setExpectations(expectationsCopy);

      // CONTINOUS IMPROVEMENT CALC
      if (selectedOption < qstnConst[Index][1] && selectedOption !== 0) {
        let calcCICopy = calcCI;
        calcCICopy[Index] = 1 - 0.25 * (qstnConst[Index][1] - selectedOption);
        setCalcCI(calcCICopy);
      } else {
        if (selectedOption === qstnConst[Index][1]) {
          let calcCICopy = calcCI;
          calcCICopy[Index] = 1;
          setCalcCI(calcCICopy);
        } else {
          let calcCICopy = calcCI;
          calcCICopy[Index] = 0;
          setCalcCI(calcCICopy);
        }
      }
      for (let i = 0; i <= 6; i++) {
        sumaCI = sumaCI + calcCI[i];
      }
      promCI = Math.round((sumaCI / 7) * 100);

      expectationsCopy = expectations;
      expectationsCopy[1] = promCI;
      setExpectations(expectationsCopy);

      // BUSINESS TRANSFORMATION CALC
      if (selectedOption < qstnConst[Index][2] && selectedOption !== 0) {
        let calcBTCopy = calcBT;
        calcBTCopy[Index] = 1 - 0.25 * (qstnConst[Index][2] - selectedOption);
        setCalcBT(calcBTCopy);
      } else {
        if (selectedOption === qstnConst[Index][2]) {
          let calcBTCopy = calcBT;
          calcBTCopy[Index] = 1;
          setCalcBT(calcBTCopy);
        } else {
          let calcBTCopy = calcBT;
          calcBTCopy[Index] = 0;
          setCalcBT(calcBTCopy);
        }
      }
      for (let i = 0; i <= 6; i++) {
        sumaBT = sumaBT + calcBT[i];
      }
      promBT = Math.round((sumaBT / 7) * 100);

      expectationsCopy = expectations;
      expectationsCopy[2] = promBT;
      setExpectations(expectationsCopy);

      // INNOVATION CALC
      if (selectedOption < qstnConst[Index][3] && selectedOption !== 0) {
        let calcINCopy = calcIN;
        calcINCopy[Index] = 1 - 0.25 * (qstnConst[Index][3] - selectedOption);
        setCalcIN(calcINCopy);
      } else {
        if (selectedOption === qstnConst[Index][3]) {
          let calcINCopy = calcIN;
          calcINCopy[Index] = 1;
          setCalcIN(calcINCopy);
        } else {
          let calcINCopy = calcIN;
          calcINCopy[Index] = 0;
          setCalcIN(calcINCopy);
        }
      }
      for (let i = 0; i <= 6; i++) {
        sumaIN = sumaIN + calcIN[i];
      }
      promIN = Math.round((sumaIN / 7) * 100);

      expectationsCopy = expectations;
      expectationsCopy[3] = promIN;
      setExpectations(expectationsCopy);
    } else if (Index <= qstn_num - 1) {
      // DAILY MANAGEMENT CALC EFFORT
      if (selectedOption > qstnConst[Index][0] && selectedOption !== 0) {
        let calcDMCopyEffort = calcDMEffort;
        calcDMCopyEffort[IndexEffort] =
          1 - 0.25 * (selectedOption - qstnConst[Index][0]);
        setCalcDMEffort(calcDMCopyEffort);
      } else {
        if (selectedOption === qstnConst[Index][0]) {
          let calcDMCopyEffort = calcDMEffort;
          calcDMCopyEffort[IndexEffort] = 1;
          setCalcDMEffort(calcDMCopyEffort);
        } else {
          let calcDMCopyEffort = calcDMEffort;
          calcDMCopyEffort[IndexEffort] = 0;
          setCalcDMEffort(calcDMCopyEffort);
        }
      }
      for (let i = 0; i <= 14; i++) {
        sumaDMEffort = sumaDMEffort + calcDMEffort[i];
      }
      promDMEffort = Math.round((sumaDMEffort / 15) * 100);

      effortCopy[0] = promDMEffort;
      setEffort(effortCopy);

      // CONTINOUS IMPROVEMENT CALC EFFORT
      if (selectedOption > qstnConst[Index][1] && selectedOption !== 0) {
        let calcCICopyEffort = calcCIEffort;
        calcCICopyEffort[IndexEffort] =
          1 - 0.25 * (selectedOption - qstnConst[Index][1]);
        setCalcCIEffort(calcCICopyEffort);
      } else {
        if (selectedOption === qstnConst[Index][1]) {
          let calcCICopyEffort = calcCIEffort;
          calcCICopyEffort[IndexEffort] = 1;
          setCalcCIEffort(calcCICopyEffort);
        } else {
          let calcCICopyEffort = calcCIEffort;
          calcCICopyEffort[IndexEffort] = 0;
          setCalcCIEffort(calcCICopyEffort);
        }
      }
      for (let i = 0; i <= 14; i++) {
        sumaCIEffort = sumaCIEffort + calcCIEffort[i];
      }
      promCIEffort = Math.round((sumaCIEffort / 15) * 100);

      effortCopy[1] = promCIEffort;
      setEffort(effortCopy);

      // BUSINESS TRANSFORMATION CALC EFFORT
      if (selectedOption > qstnConst[Index][2] && selectedOption !== 0) {
        let calcBTCopyEffort = calcBTEffort;
        calcBTCopyEffort[IndexEffort] =
          1 - 0.25 * (selectedOption - qstnConst[Index][2]);
        setCalcBTEffort(calcBTCopyEffort);
      } else {
        if (selectedOption === qstnConst[Index][2]) {
          let calcBTCopyEffort = calcBTEffort;
          calcBTCopyEffort[IndexEffort] = 1;
          setCalcBTEffort(calcBTCopyEffort);
        } else {
          let calcBTCopyEffort = calcBTEffort;
          calcBTCopyEffort[IndexEffort] = 0;
          setCalcBTEffort(calcBTCopyEffort);
        }
      }
      for (let i = 0; i <= 14; i++) {
        sumaBTEffort = sumaBTEffort + calcBTEffort[i];
      }
      promBTEffort = Math.round((sumaBTEffort / 15) * 100);

      effortCopy[2] = promBTEffort;
      setEffort(effortCopy);

      //INNOVATION CALC EFFORT
      if (selectedOption > qstnConst[Index][3] && selectedOption !== 0) {
        let calcINCopyEffort = calcINEffort;
        calcINCopyEffort[IndexEffort] =
          1 - 0.25 * (selectedOption - qstnConst[Index][3]);
        setCalcINEffort(calcINCopyEffort);
      } else {
        if (selectedOption === qstnConst[Index][3]) {
          let calcINCopyEffort = calcINEffort;
          calcINCopyEffort[IndexEffort] = 1;
          setCalcINEffort(calcINCopyEffort);
        } else {
          let calcINCopyEffort = calcINEffort;
          calcINCopyEffort[IndexEffort] = 0;
          setCalcINEffort(calcINCopyEffort);
        }
      }
      for (let i = 0; i <= 14; i++) {
        sumaINEffort = sumaINEffort + calcINEffort[i];
      }
      promINEffort = Math.round((sumaINEffort / 15) * 100);

      effortCopy[3] = promINEffort;
      setEffort(effortCopy);
    }
  }

  function handlePrevious() {
    if (indexQ != qstn_num) {
      SaveDataAnswer(indexQ, indexQEffort);
    }
    setIndexQ(indexQ - 1);
    if (indexQ > 7 && indexQ != qstn_num) {
      setIndexQEffort(indexQEffort - 1);
    }

    if (
      commentGroup[indexQ - 1] == "No comment" ||
      commentGroup[indexQ - 1] == "Sin comentario"
    ) {
      setCommentValue("");
    } else {
      setCommentValue(commentGroup[indexQ - 1]);
    }

    setSelectedOption(saved[indexQ - 1]);
    setShowTooltip(false);

    if (window.screen.width < 1024) {
      const targetElement = document.querySelector("#question_isa");

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    }
  }

  function handleNext() {
    if (indexQ != qstn_num) {
      SaveDataAnswer(indexQ, indexQEffort);
    }
    setIndexQ(indexQ + 1);
    if (indexQ > 6 && indexQ != qstn_num - 1) {
      setIndexQEffort(indexQEffort + 1);
    }

    if (
      commentGroup[indexQ + 1] == "No comment" ||
      commentGroup[indexQ + 1] == "Sin comentario" ||
      commentGroup[indexQ + 1] == ""
    ) {
      setCommentValue("");
    } else {
      setCommentValue(commentGroup[indexQ + 1]);
    }

    if (indexQ == qstn_num - 1) {
      setSelectedOption(0);
      // setCommentValue("")
    } else {
      setSelectedOption(saved[indexQ + 1]);
    }
    setShowTooltip(false);

    if (window.screen.width < 1024) {
      const targetElement = document.querySelector("#question_isa");

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    }
  }

  function setLoginEmail() {
    if (auth && auth.currentUser?.email) {
      formData.email = auth.currentUser?.email;

      if (auth && auth.currentUser?.id) {
        const StrToInt = parseInt(auth.currentUser?.id, 10);
        authUserData.user_id = StrToInt;
      }
      if (auth && auth.currentUser?.name) {
        formData.name = auth.currentUser?.name;
      }
      if (auth && auth.currentUser?.last_name) {
        formData.last_name = auth.currentUser?.last_name;
      }
      if (auth && auth.currentUser?.phone_country_zone) {
        formData.phone_country_zone = auth.currentUser?.phone_country_zone;
      }

      if (auth && auth.currentUser?.phone) {
        formData.phone_number = auth.currentUser?.phone;
      }

      setDisplayEmailModal(true);
    } else {
      setDisplayEmailModal(true);
    }
  }

  function CloseModal() {
    const error_reset = {
      name: "",
      last_name: "",
      email: "",
      phone_country_zone: "",
      phone_number: "",
    };
    setFormErrors(error_reset);

    const data_reset = {
      name: "",
      last_name: "",
      email: "",
      phone_country_zone: "+1",
      phone_number: "",
    };
    setFormData(data_reset);

    authUserData.user_id = null;
    setFormToDisplay("email");
    setDisplayEmailModal(false);
  }

  const generatePDF = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const errors = {
      name: "",
      last_name: "",
      email: "",
      phone_country_zone: "",
      phone_number: "",
    };

    let login_errors = 0;

    if (!formData.email) {
      errors.email = isaGraphContent.error_email_1;
      login_errors = login_errors + 1;
    } else if (
      !formData.email.match(/^[\w-.]+(\+[\w-]*)?@([\w-]+\.)+[\w-]{2,4}$/)
    ) {
      errors.email = isaGraphContent.error_email_2;
      login_errors = login_errors + 1;
    }
    if (!formData.name) {
      errors.name = isaGraphContent.error_name;
      login_errors = login_errors + 1;
    }

    if (!formData.last_name) {
      errors.last_name = isaGraphContent.error_last_name;
      login_errors = login_errors + 1;
    }

    if (!formData.phone_number) {
      errors.phone_number = isaGraphContent.error_phone_1;
      login_errors = login_errors + 1;
    } else if (formData.phone_number.length < 10) {
      errors.phone_number = isaGraphContent.error_phone_2;
      login_errors = login_errors + 1;
    }

    if (login_errors != 0) {
      setFormErrors(errors);
      return;
    }

    let useremail = formData.email;
    let userid = authUserData.user_id;
    let name = formData.name;
    let last_name = formData.last_name;
    let phone_country_zone = formData.phone_country_zone;
    let phone_number = formData.phone_number;

    let metaViewportTag = document.querySelector('meta[name="viewport"]');

    if (window.screen.width < 1024) {
      if (metaViewportTag) {
        metaViewportTag.setAttribute("content", "width=1200");
        // console.log("Viewport meta tag updated successfully.");
      } else {
        console.log('Meta tag with name="viewport" not found.');
      }
    }
    const graphimg = document.getElementById("chart")!;
    let pdf64;

    setTimeout(() => {
      html2canvas(graphimg, {
        logging: true,
        useCORS: true,
        scale: 1,
      }).then((canvas) => {
        const imgWidth = 160;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        const imgData = canvas.toDataURL("img/png");
        const pdf = new jsPDF("p", "mm", "a4");

        const LogoImg = "/images/illustrations/isa/gbci_logo.png";
        const MediaImg = "/images/illustrations/isa/gbci_media.png";
        const ContactImg = "/images/illustrations/isa/gbci_watermark.png";

        if (window.screen.width < 1024) {
          if (metaViewportTag) {
            metaViewportTag.setAttribute(
              "content",
              "width=device-width, initial-scale=1",
            );
            // console.log("Viewport meta tag updated successfully.");
          } else {
            console.log('Meta tag with name="viewport" not found.');
          }
        }

        // Page 1
        pdf.addImage(LogoImg, "PNG", 10, 10, 41.25, 9);

        pdf.addImage(imgData, "PNG", 20, 100, imgWidth, imgHeight);

        pdf.addImage(MediaImg, "PNG", 10, 265, 85, 26);

        pdf.addImage(ContactImg, "PNG", 130, 135, 100, 200);

        // Question Pages
        pdf.addPage();
        pdf.addImage(LogoImg, "PNG", 10, 10, 41.25, 9);
        pdf.addImage(MediaImg, "PNG", 10, 265, 85, 26);
        pdf.addImage(ContactImg, "PNG", 130, 135, 100, 200);

        let Position = 0;
        let Ycoord = 30;
        for (let i = 0; i < qstn_num; i++) {
          if (
            Position === 0 &&
            (Ycoord === 30 || Ycoord === 90 || Ycoord === 150 || Ycoord === 210)
          ) {
            pdf.setFont("Lato-Black", "normal");
            pdf.setFontSize(12);
            pdf.setTextColor(0, 0, 0);
            pdf.text(
              isaGraphContent.pdf_question_index_1 +
                (i + 1) +
                isaGraphContent.pdf_question_index_2 +
                qstn_num,
              10,
              Ycoord,
              {
                maxWidth: 190,
              },
            );
            Position = Position + 1;
            Ycoord = Ycoord + 10;
          }
          if (
            Position === 1 &&
            (Ycoord === 40 ||
              Ycoord === 100 ||
              Ycoord === 160 ||
              Ycoord === 220)
          ) {
            pdf.setFont("Lato-Bold", "normal");
            pdf.text(qstn[i], 10, Ycoord, { maxWidth: 190 });
            Position = Position + 1;
            Ycoord = Ycoord + 15;
          }
          if (
            Position === 2 &&
            (Ycoord === 55 ||
              Ycoord === 115 ||
              Ycoord === 175 ||
              Ycoord === 235)
          ) {
            pdf.setFont("Lato-Regular", "normal");
            pdf.setTextColor(153, 153, 153);
            pdf.text(isaGraphContent.pdf_answer, 10, Ycoord, { maxWidth: 190 });
            Position = Position + 1;
            Ycoord = Ycoord + 5;
          }
          if (
            Position === 3 &&
            (Ycoord === 60 ||
              Ycoord === 120 ||
              Ycoord === 180 ||
              Ycoord === 240)
          ) {
            pdf.setTextColor(0, 0, 0);
            if (saved[i] === 1) {
              pdf.text(as1[i], 15, Ycoord, { maxWidth: 190 });
              Position = Position + 1;
              Ycoord = Ycoord + 10;
            }
            if (saved[i] === 2) {
              pdf.text(as2[i], 15, Ycoord, { maxWidth: 190 });
              Position = Position + 1;
              Ycoord = Ycoord + 10;
            }
            if (saved[i] === 3) {
              pdf.text(as3[i], 15, Ycoord, { maxWidth: 190 });
              Position = Position + 1;
              Ycoord = Ycoord + 10;
            }
          }
          if (
            Position === 4 &&
            (Ycoord === 70 ||
              Ycoord === 130 ||
              Ycoord === 190 ||
              Ycoord === 250)
          ) {
            pdf.setTextColor(153, 153, 153);
            pdf.text(isaGraphContent.pdf_comments, 10, Ycoord, {
              maxWidth: 190,
            });
            Position = Position + 1;
            Ycoord = Ycoord + 5;
          }
          if (
            Position === 5 &&
            (Ycoord === 75 ||
              Ycoord === 135 ||
              Ycoord === 195 ||
              Ycoord === 255)
          ) {
            pdf.setTextColor(0, 0, 0);
            pdf.text(commentGroup[i], 15, Ycoord, { maxWidth: 190 });
            Position = 0;
            Ycoord = Ycoord + 15;
          }
          if (Ycoord === 270) {
            if (i < qstn_num - 1) {
              Ycoord = 30;
              Position = 0;
              pdf.addPage();
              pdf.addImage(LogoImg, "PNG", 10, 10, 41.25, 9);
              pdf.addImage(MediaImg, "PNG", 10, 265, 85, 26);
              pdf.addImage(ContactImg, "PNG", 130, 135, 100, 200);
            }
          }
        }

        pdf64 = pdf.output("datauristring");
        let pdf64encoded = pdf64.split(",")[1];

        const pdfBytes = pdf.output("arraybuffer");

        const pdfSizeInBytes = pdfBytes.byteLength;

        // Convert the size to MB
        const pdfSizeInMB = pdfSizeInBytes / (1024 * 1024);

        // console.log('PDF size: ' + pdfSizeInMB.toFixed(6) + ' MB');

        let jsonpdf = {
          user_id: userid,
          name: name,
          last_name: last_name,
          phone_country_zone: phone_country_zone,
          phone_number: phone_number,
          delivery_list: [useremail],
          attachment_in_base64: pdf64encoded,
          answers: saved,
          comments: commentGroup,
          graph_expectations: expectations,
          graph_effort: effort,
        };

        setDisplayEmailModal(true);
        setFormToDisplay("wait");

        fetch(`${SERVER_API_URL}/api/v1/tool_isa/send/isa`, {
          method: "POST",
          body: JSON.stringify(jsonpdf),
          headers: { "Content-Type": "application/json" },
        })
          .then((response) => {
            if (response.status === 200) {
              setDisplayEmailModal(true);
              setFormToDisplay("success");
            } else {
              setDisplayEmailModal(true);
              setFormToDisplay("error");
            }
          })
          .catch((error) => {
            const err = error.message;
            setDisplayEmailModal(true);
            setFormToDisplay("error");
          });
      });
    }, 100);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setFormData({ ...formData, [e.target.id]: e.target.value });
    setFormErrors({ ...formErrors, [e.target.id]: "" }); // Remove the error on type
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    // setFormData({ ...formData, [e.target.id]: e.target.value });
    const { id, value } = e.target;

    setFormData({ ...formData, [id]: value });
    setFormErrors({ ...formErrors, [e.target.id]: "" }); // Remove error on type
  };

  return (
    <div>
      <div className="flex justify-center pb-6">
        <div className="w-11/12 max-w-3xl bg-white shadow-md rounded-2xl">
          <div className="text-center text-xl font-bold py-5">
            {isaGraphContent.graph_title}
          </div>
          <div
            className="flex flex-row h-72 px-4 pb-4 justify-center md:h-96"
            id="chart"
          >
            <div className="flex w-11/12">
              <Bar
                options={{
                  maintainAspectRatio: false,
                  indexAxis: "y",
                  responsive: true,

                  plugins: {
                    tooltip: {
                      enabled: false,
                    },
                    datalabels: {
                      formatter: function (values: any, context: any) {
                        if (values <= 3) {
                          return "";
                        } else {
                          return values + "%";
                        }
                      },
                      color: "white",
                      font: function (context: any) {
                        let width = context.chart.width;
                        let size = Math.round(width / 40);
                        return {
                          size: size,
                        };
                      },
                    },

                    legend: {
                      labels: {
                        font: function (context: any) {
                          let width = context.chart.width;
                          let size = Math.round(width / 46);
                          return {
                            size: size,
                          };
                        },
                      },
                    },
                  },

                  scales: {
                    x: {
                      min: 0,
                      max: 100,
                      ticks: {
                        maxTicksLimit: 2,
                        align: "center",
                        callback: function (value: any) {
                          return value + "%";
                        },
                      },
                      grid: {
                        color: "black",
                      },
                    },
                    y: {
                      type: "category",
                      ticks: {
                        crossAlign: "far",
                        align: "center",
                        font: function (context: any) {
                          let width = context.chart.width;
                          let size = Math.round(width / 36);
                          return {
                            size: size,
                            family: "Lato",
                          };
                        },
                      },
                      grid: {
                        color: "black",
                      },
                    },
                  },
                }}
                data={data}
                plugins={[ChartDataLabels]}
              ></Bar>
            </div>
            <div className="flex justify-around items-center flex-col w-1/12 py-8">
              <DailyManagementSVG className="fill-gbci-accent"></DailyManagementSVG>
              <ContinousImprovementSVG className="fill-gbci-accent"></ContinousImprovementSVG>
              <BusinesssTransformationSVG className="stroke-gbci-accent"></BusinesssTransformationSVG>
              <InnovationSVG className="fill-gbci-accent"></InnovationSVG>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center pt-6 pb-32">
        <div
          id="question_isa"
          className="w-11/12 max-w-3xl bg-white shadow-md rounded-2xl"
        >
          <div className="questions-isa-space">
            {indexQ >= qstn_num ? (
              <div className="p-4">
                <div className="text-xl font-bold my-6">{qstn[qstn_num]}</div>
                <div className="flex flex-row justify-between gap-2">
                  <div className="flex">
                    <button
                      className="w-full bg-transparent border border-red-500 hover:brightness-75 transition-all duration-150 p-4 text-red-500 font-bold rounded-md shadow-md"
                      onClick={BtnReset}
                    >
                      {isaGraphContent.button_reset}
                    </button>
                  </div>
                  <div className="flex gap-2 flex-col md:flex-row">
                    {indexQ == 0 ? (
                      <button
                        disabled
                        className="p-4 text-white font-bold rounded-md shadow-md disabled:bg-gray-400 opacity-75 w-full"
                      >
                        {isaGraphContent.button_previous}
                      </button>
                    ) : (
                      <Button onClick={handlePrevious}>
                        {isaGraphContent.button_previous}
                      </Button>
                    )}
                    {selectedOption == 0 && indexQ <= qstn_num - 1 ? (
                      <button
                        disabled
                        className="p-4 text-white font-bold rounded-md shadow-md disabled:bg-gray-400 opacity-75"
                      >
                        {isaGraphContent.button_next}
                      </button>
                    ) : indexQ <= qstn_num - 1 ? (
                      <Button onClick={handleNext}>
                        {isaGraphContent.button_next}
                      </Button>
                    ) : (
                      <Button
                        onClick={() => {
                          setLoginEmail();
                        }}
                      >
                        {isaGraphContent.button_results}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className="flex text-left justify-between items-center p-4">
                  <div className="text-base w-2/4 font-bold">
                    {isaGraphContent.question_index_1} {indexQ + 1}{" "}
                    {isaGraphContent.question_index_2} {qstn_num}
                  </div>
                  <div className="text-base w-2/4">
                    <ProgressBar percentage={current * (indexQ + 1)} />
                  </div>
                </div>

                <div className="p-4">
                  <div className={`h-48 flex flex-col justify-center md:h-16`}>
                    <div className="text-xl font-bold">{qstn[indexQ]}</div>
                  </div>
                  <div>
                    <div className="flex flex-col h-44 justify-center md:h-32">
                      <div className="flex items-center mb-4">
                        <input
                          type="radio"
                          id="option1"
                          value={1}
                          checked={selectedOption === 1}
                          onChange={handleOptionChange}
                          className="mr-2 relative peer shrink-0 appearance-none w-6 h-6 border-2 rounded-full border-gbci-primary bg-white checked:bg-gbci-primary checked:border-0"
                        />
                        <svg
                          className="absolute w-4 h-4 ml-1 text-white hidden peer-checked:block"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <label className="font-black" htmlFor="option1">
                          {as1[indexQ]}
                        </label>
                      </div>
                      <div className="flex items-center mb-4">
                        <input
                          type="radio"
                          id="option2"
                          value={2}
                          checked={selectedOption === 2}
                          onChange={handleOptionChange}
                          className="mr-2 relative peer shrink-0 appearance-none w-6 h-6 border-2 rounded-full border-gbci-primary bg-white checked:bg-gbci-primary checked:border-0"
                        />
                        <svg
                          className="absolute w-4 h-4 ml-1 text-white hidden peer-checked:block"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <label className="font-black" htmlFor="option2">
                          {as2[indexQ]}
                        </label>
                      </div>
                      <div className="flex items-center mb-4">
                        <input
                          type="radio"
                          id="option3"
                          value={3}
                          checked={selectedOption === 3}
                          onChange={handleOptionChange}
                          className="mr-2 relative peer shrink-0 appearance-none w-6 h-6 border-2 rounded-full border-gbci-primary bg-white checked:bg-gbci-primary checked:border-0"
                        />
                        <svg
                          className="absolute w-4 h-4 ml-1 text-white hidden peer-checked:block"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <label className="font-black" htmlFor="option3">
                          {as3[indexQ]}
                        </label>
                      </div>
                    </div>

                    <div className="flex flex-col items-center md:flex-row">
                      <div className="flex flex-row w-full h-full justify-around items-end py-4 px-0 md:py-4">
                        <textarea
                          id="textarea"
                          placeholder={isaGraphContent.text_area}
                          value={commentValue}
                          onChange={handleCommentChange}
                          className="w-full h-32 p-4 rounded-md border border-slate-300 resize-none"
                          maxLength={200}
                        />
                      </div>
                      <div className="flex flex-row w-full h-full justify-between items-end py-4 px-0 gap-2 md:p-4 md:justify-around">
                        <div className="flex flex-col ">
                          {indexQ <= 6 ? (
                            <div className="relative inline-block">
                              <button
                                className="w-full bg-transparent border border-gbci-primary my-2 hover:brightness-75 transition-all duration-150 p-4 text-gbci-primary font-bold rounded-md shadow-md"
                                onClick={changeTooltip}
                              >
                                {isaGraphContent.button_additional}
                              </button>
                              {showTooltip && (
                                <div>
                                  <div className="absolute border-2 border-gbci-primary bg-white shadow-lg rounded p-2 text-sm z-10 bottom-20 left-1/2 transform -translate-x-1/2 mt-2 w-48 break-words">
                                    {addinfo[indexQ]}
                                  </div>
                                  <div className="absolute bg-transparent -mb-0.5 text-gbci-primary text-3xl z-10 bottom-14 left-1/2 transform -translate-x-1/2 select-none">
                                    &#9660;
                                  </div>
                                </div>
                              )}
                            </div>
                          ) : (
                            <button
                              disabled
                              className="w-full bg-transparent border border-gray-400 my-2 p-4 rounded-md shadow-md disabled:text-gray-400 opacity-75 font-bold"
                            >
                              {isaGraphContent.button_additional}
                            </button>
                          )}
                          <button
                            className="w-full bg-transparent border border-red-500 hover:brightness-75 transition-all duration-150 p-4 text-red-500 font-bold rounded-md shadow-md"
                            onClick={BtnReset}
                          >
                            {isaGraphContent.button_reset}
                          </button>
                        </div>
                        <div className="flex items-center gap-2 flex-col md:flex-row">
                          {indexQ == 0 ? (
                            <button
                              disabled
                              className="p-4 text-white font-bold rounded-md shadow-md disabled:bg-gray-400 opacity-75 w-full"
                            >
                              {isaGraphContent.button_previous}
                            </button>
                          ) : (
                            <button
                              className="bg-gradient-to-br from-gbci-primary to-gbci-accent hover:brightness-75 transition-all duration-150 p-4 text-white font-bold rounded-md shadow-md w-full"
                              onClick={handlePrevious}
                            >
                              {isaGraphContent.button_previous}
                            </button>
                          )}
                          {selectedOption == 0 && indexQ <= qstn_num - 1 ? (
                            <button
                              disabled
                              className="p-4 text-white font-bold rounded-md shadow-md disabled:bg-gray-400 opacity-75 w-full"
                            >
                              {isaGraphContent.button_next}
                            </button>
                          ) : indexQ <= qstn_num - 1 ? (
                            <button
                              className="bg-gradient-to-br from-gbci-primary to-gbci-accent hover:brightness-75 transition-all duration-150 p-4 text-white font-bold rounded-md shadow-md w-full"
                              onClick={handleNext}
                            >
                              {isaGraphContent.button_next}
                            </button>
                          ) : (
                            <button
                              onClick={() => {
                                setLoginEmail();
                              }}
                            >
                              {isaGraphContent.button_results}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {displayEmailModal && (
        <Modal handleClose={CloseModal} size="small">
          {formToDisplay === "email" ? (
            <div>
              <div className="text-3xl font-bold text-center">
                {isaGraphContent.modal_email_title}
              </div>
              <div className="mt-2 mb-4 text-xl text-slate-400 text-center">
                {isaGraphContent.modal_email_desc}
              </div>

              <form
                className="w-full flex flex-col gap-4"
                onSubmit={generatePDF}
              >
                <label className="text-slate-400 font-bold flex flex-col">
                  {isaGraphContent.modal_name_label}
                  <input
                    className="border-2 rounded-lg p-2 w-full"
                    placeholder={isaGraphContent.modal_name}
                    type="text"
                    id="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                  <p
                    className={
                      formErrors.name
                        ? "text-red-500"
                        : "text-transparent select-none"
                    }
                  >
                    {formErrors.name || "z"}
                  </p>
                </label>

                <label className="text-slate-400 font-bold flex flex-col">
                  {isaGraphContent.modal_last_name_label}
                  <input
                    className="border-2 rounded-lg p-2 w-full"
                    placeholder={isaGraphContent.modal_last_name}
                    type="text"
                    id="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                  />
                  <p
                    className={
                      formErrors.last_name
                        ? "text-red-500"
                        : "text-transparent select-none"
                    }
                  >
                    {formErrors.last_name || "z"}
                  </p>
                </label>
                <label className="text-slate-400 font-bold flex flex-col">
                  {isaGraphContent.modal_phone_number_label}
                  <div className="w-full flex">
                    <select
                      className="border-2 rounded-lg p-2"
                      id="phone_country_zone"
                      value={formData.phone_country_zone}
                      onChange={handleChangeSelect}
                    >
                      <option value="+1">+1 (US)</option>
                      <option value="+52">+52 (MXN)</option>
                    </select>
                    <input
                      className="border-2 rounded-lg p-2 w-full"
                      placeholder={isaGraphContent.modal_phone_number}
                      type="tel"
                      id="phone_number"
                      value={formData.phone_number}
                      onChange={handleChange}
                      pattern="[0-9]*"
                      inputMode="numeric"
                    />
                  </div>
                  <p
                    className={
                      formErrors.phone_number
                        ? "text-red-500"
                        : "text-transparent select-none"
                    }
                  >
                    {formErrors.phone_number || "z"}
                  </p>
                </label>

                <label className="text-slate-400 font-bold flex flex-col gap-2">
                  {isaGraphContent.modal_email_label}
                  <input
                    className="border-2 rounded-lg p-2 w-full"
                    placeholder={isaGraphContent.modal_email}
                    type="text"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    autoFocus={true}
                  />
                  <div
                    className={
                      formErrors.email
                        ? "text-red-500"
                        : "text-transparent select-none"
                    }
                  >
                    {formErrors.email || "z"}
                  </div>
                </label>

                <Button size="large" type="submit">
                  {isaGraphContent.modal_email_send}
                </Button>
              </form>
            </div>
          ) : formToDisplay === "wait" ? (
            <div>
              <div className="text-3xl font-bold text-center">
                {isaGraphContent.wait_email_title}
              </div>
              <div className="mt-2 mb-4 text-xl text-slate-400 text-center">
                {isaGraphContent.wait_email}
              </div>
            </div>
          ) : formToDisplay === "success" ? (
            <div>
              <div className="text-3xl font-bold text-center">
                {isaGraphContent.success_email_title}
              </div>
              <div className="mt-2 mb-4 text-xl text-slate-400 text-center">
                {isaGraphContent.success_email}
              </div>

              <form
                className="w-full flex flex-col gap-4"
                onSubmit={CloseModal}
              >
                <Button size="large" type="submit">
                  {isaGraphContent.success_understood}
                </Button>
              </form>
            </div>
          ) : formToDisplay === "error" ? (
            <div>
              <div className="text-3xl font-bold text-center">
                {isaGraphContent.error_email_title}
              </div>
              <div className="mt-2 mb-4 text-xl text-slate-400 text-center">
                {isaGraphContent.error_email}
              </div>

              <form
                className="w-full flex flex-col gap-4"
                onSubmit={CloseModal}
              >
                <Button size="large" type="submit">
                  {isaGraphContent.error_understood}
                </Button>
              </form>
            </div>
          ) : (
            <div>
              <div className="text-3xl font-bold text-center">
                {isaGraphContent.modal_question_reset}
              </div>
              <div className="flex flex-col mt-8 justify-between px-2 md:px-20 md:flex-row">
                <button
                  onClick={AcceptReset}
                  className="bg-transparent text-2xl border border-gbci-primary my-2 hover:brightness-75 transition-all duration-150 p-4 px-8 md:px-12 text-gbci-primary font-bold rounded-md shadow-md"
                >
                  {isaGraphContent.modal_question_reset_yes}
                </button>
                <button
                  onClick={DeclineReset}
                  className="bg-transparent text-2xl border border-red-500 my-2 hover:brightness-75 transition-all duration-150 p-4 px-8 md:px-12 text-red-500 font-bold rounded-md shadow-md"
                >
                  {isaGraphContent.modal_question_reset_no}
                </button>
              </div>
            </div>
          )}
        </Modal>
      )}
    </div>
  );
};

export default IsaGraph;
